import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-primary-900/40 bg-primary-950/70">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-10 sm:grid-cols-2 md:px-6 lg:grid-cols-4 lg:px-10">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-tv-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-bold text-foreground-950">
              芒果<span className="text-primary-400">视频</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
            聚合热门影视剧集、电影、综艺与短视频的内容发现平台，帮你快速找到想看的下一部。
          </p>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-foreground-900">内容分类</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/category?type=电影" className="text-foreground-600 transition-colors hover:text-primary-400">电影</Link></li>
            <li><Link to="/category?type=电视剧" className="text-foreground-600 transition-colors hover:text-primary-400">电视剧</Link></li>
            <li><Link to="/category?type=综艺" className="text-foreground-600 transition-colors hover:text-primary-400">综艺</Link></li>
            <li><Link to="/category?type=短视频" className="text-foreground-600 transition-colors hover:text-primary-400">短视频</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-foreground-900">发现更多</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/" className="text-foreground-600 transition-colors hover:text-primary-400">首页推荐</Link></li>
            <li><Link to="/search" className="text-foreground-600 transition-colors hover:text-primary-400">全站搜索</Link></li>
            <li><Link to="/favorites" className="text-foreground-600 transition-colors hover:text-primary-400">我的收藏</Link></li>
            <li><Link to="/about" className="text-foreground-600 transition-colors hover:text-primary-400">关于我们</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-foreground-900">用户须知</h4>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            本站为影视内容发现演示站点，页面中的影视名称、封面与资料均为虚构示例数据，不提供真实视频播放或下载服务。
          </p>
        </div>
      </div>

      <div className="border-t border-primary-900/40">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6 lg:px-10">
          <p>© 2026 芒果视频 · 仅供内容发现与演示使用</p>
          <p>内容数据为虚构示例，请以正式上线版本为准</p>
        </div>
      </div>
    </footer>
  );
}